'use client'

import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react'

import { env } from '@/env'

// This should only render on client-side and only when in draft mode
export default function LivePreviewProvider({ children, isDraftMode }: { children: React.ReactNode; isDraftMode: boolean }) {
  if (!isDraftMode) {
    return children
  }

  return (
    <ContentfulLivePreviewProvider
      space={env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}
      environment={env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}
      enableInspectorMode={isDraftMode}
      enableLiveUpdates={isDraftMode}
      locale="en-US"
    >
      {children}
    </ContentfulLivePreviewProvider>
  )
}
